__turbopack_context__.v({
  "inner-container": "ItemsPageHeader-module-scss-module__qwF0eG__inner-container",
  "title-and-content-content": "ItemsPageHeader-module-scss-module__qwF0eG__title-and-content-content",
  "title-and-content-title": "ItemsPageHeader-module-scss-module__qwF0eG__title-and-content-title",
});
